import { ButtonProps as MuiButtonProps } from "@mui/material";

import { Button } from "./Button";

interface YellowButtonProps extends Omit<MuiButtonProps, "variant"> {
  children: React.ReactNode;
}

export const YellowButton: React.FC<YellowButtonProps> = ({ children, sx, ...props }) => {
  return (
    <Button
      variant="contained"
      sx={{
        backgroundColor: "#ffd400",
        color: "#000000",
        border: "1px solid #ffd400",
        borderRadius: "5px",
        textTransform: "uppercase",
        fontFamily: "Montserrat",
        fontSize: "10px",
        fontWeight: 600,
        letterSpacing: "0.6px",
        padding: "9px 16px",
        height: "40px",
        cursor: "pointer",
        transition: "all 0.5s ease-in-out",
        "&:hover": {
          backgroundColor: "#f5b858",
          borderColor: "#f5b858",
        },
        "&:focus": {
          outline: "none",
        },
        "&:disabled": {
          backgroundColor: "#808080",
          borderColor: "#808080",
          cursor: "not-allowed",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default YellowButton;
